/**
 * @generated SignedSource<<c5a7bea3d61ce6ea787e0de9084d182c>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedModuleItemTile_linkData$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SeoLink_linkData">;
  readonly " $fragmentType": "HpSharedModuleItemTile_linkData";
};
export type HpSharedModuleItemTile_linkData$key = {
  readonly " $data"?: HpSharedModuleItemTile_linkData$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedModuleItemTile_linkData">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedModuleItemTile_linkData",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SeoLink_linkData"
    }
  ],
  "type": "LinkData",
  "abstractKey": null
};

(node as any).hash = "e2af1a6ad5618dbc9a3c8959a600a017";

export default node;
